import styled from "@emotion/styled";

export const StatusBox = styled.div`
  position: relative;
  display: inline-block;
`;
